import { Navigate, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../Utils/axiosInstance";
import { backendbaseUrl } from "../../Utils/baseUrl";

import { InputGroup, InputGroupText } from "reactstrap";
interface FormDataTypes {
  organizationName: string;
  buyer: string;
  email: string;
  phoneNumber: string;
  countrySelect: any;
  jobTitle: any,
  commodityType: any,
  plans: any;
  password: string;
}
interface Plan {
  id: number | string;
  name: string;
  description: string;
  price: string;
  country: any;
}

const PricingPlan = () => {
  const { id } = useParams();

  const [plansData, setPlansData] = useState<Plan[]>([]);

  const [formData, setFormData] = useState<FormDataTypes>({
    organizationName: "",
    buyer: "",
    email: "",
    phoneNumber: "",
    countrySelect: "",
    plans: id,
    password: "",
    jobTitle: "",
    commodityType: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  const navigate = useNavigate();
  const submitHandler = (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.organizationName) {
      return toast.error("Organization Name cannot be empty");
    }
    if (!formData.buyer) {
      return toast.error("Name of the Buyer cannot be empty");
    }
    if (!formData.email || !validateEmail(formData.email)) {
      return toast.error("Enter a valid Email");
    }
    if (!formData.phoneNumber || formData.phoneNumber.length < 10) {
      return toast.error("Phone Number must be at least 10 digits");
    }

    if (!formData.password || formData.password.length < 6) {
      return toast.error("Password must be at least 6 characters");
    }

    const submetFormData = async () => {
      const successUrl = `${window.location.origin}/payment/success`;
      if (formData.countrySelect.trim() === "") {
        formData.countrySelect = defaultCurrency.country.id;
      }
      try {
        const response = await axiosInstance.post(
          `${backendbaseUrl}/users/create-checkout-session/`,
          {
            formdata: formData,
            success_url: successUrl,
          }
        );
        if (response.status === 200) {
          console.log(response.data.checkout_url);
          window.location.href = response.data.checkout_url;
        }
      } catch (error: any) {
        if (error.response) {
          if (error.response.status === 401) {
            toast.error("Unauthorized");
          } else {
            toast.error(
              error.response.data.message || "An unknown error occurred"
            );
          }
        } else {
          toast.error("Network error or server is down");
        }
      }
    };

    submetFormData();
  };

  const apiPlan = async () => {
    const response = await axiosInstance.get(
      `${backendbaseUrl}/plans/pricing-plans/`
    );
    const data = response.data;
    console.log(data);
    setPlansData(data);
  };

  useEffect(() => {
    apiPlan();
  }, []);
  // console.log(plans)

  const [countryOptions, SetCountryOptions] = useState([]);
  const [currency, SetCurrency] = useState<any[]>([]);
  const defaultCurrency =
    currency.find((currency) => currency.is_default) || currency[0];
  const [selectedCurrency, setSelectedCurrency] = useState(
    defaultCurrency?.country?.id || ""
  );
  const planInfo = plansData.find((item) => item.id === id);
  console.log(defaultCurrency, "default curency");
  const handleCurrencyChange = (e: any) => {
    setSelectedCurrency(e.target.value);
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  useEffect(() => {
    const getCountryList = async () => {
      try {
        const response = await axiosInstance.get(
          `${backendbaseUrl}/settings/country/default-country/`
        );
        if (response.status === 200) {
          const countryListData =
            response?.data?.map((c: any) => ({
              value: c.country.id,
              label: c.country.country_name,
            })) || [];

          SetCountryOptions(countryListData);
          SetCurrency(response.data);
        }
      } catch (error: any) {
        if (error.response) {
          if (error.response.status === 401) {
            toast.error("Unauthorized");
          } else {
            toast.error(
              error.response.data.message || "An unknown error occurred"
            );
          }
        } else {
          toast.error("Network error or server is down");
        }
      }
    };

    getCountryList();
  }, []);

  return (
    <section className="align-items-center d-flex justify-content-center register_company">
      <Container>
        <Row>
          <Col md={7}>
            <div className="card m-auto">
              <Form onSubmit={submitHandler}>
                <div className="card-header">
                  <h2 className="mb-0 card-title">Register Your Company</h2>
                </div>
                <div className="card-body">
                  <Row>

                    <Col md={6}>
                      <FormGroup>
                        <Label for="buyer">Name </Label>
                        <Input
                          id="buyer"
                          name="buyer"
                          placeholder="Enter Name of the Buyer"
                          type="text"
                          value={formData.buyer}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="email">Job Title </Label>
                        <Input
                          id="jobTitle"
                          type="text"
                          name="email"
                          placeholder="Job Title"
                          value={formData.jobTitle}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={6}>
                      <FormGroup>
                        <Label for="organizationName">Company </Label>
                        <Input
                          id="organizationName"
                          name="organizationName"
                          placeholder="Enter Company Name"
                          type="text"
                          value={formData.organizationName}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="commodityType">Commodity Type</Label>
                        <Input
                          id="commodityType"
                          type="select"
                          name="commodityType"
                          value={formData.commodityType}
                          onChange={handleChange}
                        >
                          <option value="">Select a commodity</option>
                          <option value="Crude Oil">Crude Oil</option>
                          <option value="Natural Gas">Natural Gas</option>
                          <option value="Gasoline">Gasoline</option>
                          <option value="Diesel">Diesel</option>
                          <option value="Jet Fuel">Jet Fuel</option>
                          <option value="Coal">Coal</option>
                          <option value="Coal">All</option>
                          {/* Add more commodities as needed */}
                        </Input>
                      </FormGroup>
                    </Col>


                    <Col md={6}>
                      <FormGroup>
                        <Label for="email">Email</Label>
                        <Input
                          id="email"
                          type="email"
                          name="email"
                          placeholder="Email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>



                    <Col md={6}>
                      <FormGroup>
                        <Label for="phoneNumber">Phone</Label>
                        <Input
                          id="phoneNumber"
                          type="number"
                          name="phoneNumber"
                          placeholder="Enter Phone Number"
                          value={formData.phoneNumber}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup className="pricingPlan__country">
                        <Label for="countrySelect">Country</Label>

                        <InputGroupText>
                          <select
                            value={selectedCurrency}
                            name="countrySelect"
                            onChange={handleCurrencyChange}
                            className="form-select"
                          >
                            {currency.length > 0 ? (
                              currency.map((currencyItem: any) => (
                                <option
                                  key={currencyItem?.country?.id}
                                  value={currencyItem?.country?.id}
                                  onChange={handleCurrencyChange}
                                >
                                  (
                                  {currencyItem?.country?.country_name ||
                                    "Unknown"}
                                  )
                                </option>
                              ))
                            ) : (
                              <option disabled>No currencies available</option>
                            )}
                          </select>
                        </InputGroupText>
                      </FormGroup>
                    </Col>

                    <Col md={6}>
                      <FormGroup>
                        <Label for="password">Password</Label>
                        <Input
                          id="password"
                          type="password"
                          name="password"
                          placeholder="Enter Password"
                          value={formData.password}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button type="submit">Buy Plan</Button>
                </div>
              </Form>
            </div>
          </Col>
          <Col md={4}>
            <div>
              {planInfo && (
                <div className="card m-auto">
                  <div className="card-body">
                    <h2>{planInfo.name}</h2>
                    <p>{planInfo.description}</p>
                    <p>
                      Price: ${planInfo.price} {planInfo.id}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default PricingPlan;
